import * as React from 'react';
import * as styles from './styles.css';

export const Respective: React.FC = props => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>{props.children}</div>
    </div>
  );
};

Respective.displayName = 'Respective';
